<template>
	<div class="autocomplete">
		<!-- <button v-on:click="test()">Test</button> -->
		<!-- input to enter search string -->
		<button class="button"
			v-on:click="comboKeyEnter"
		>
			<img class="button-image" :src="require('../assets/Check.png')"/>
		</button>
		<div class="dropdown">
			<input class="input"
				ref="filterInput"
				v-bind:size='textLen'
				v-model="filterInput"
				contenteditable='true'
				v-on:keydown="comboKeyDown"
				v-on:keydown.enter="comboKeyEnter"
			/>
			<ul class="dropdown--list"
				v-if="!vars.editOnly"
				:class='{"dropdown--list-show": nods.length>0}'
			>
				<li class="dropdown--li"
					:class='{"dropdown--li-active": listPointer === index}'
					v-for="(item, index) in nods" v-bind:key="index"
					v-text="item.name"
					v-on:click="onListClick(item,index)"
				/>
			</ul>
		</div>
	</div>
</template>

<script>
	import _ from 'lodash'  // this is needed to use the sort function

	import getNod from '../graphql/server/Nod/Nod.gql'
	
	export default { 
		name: 'AutoComplete',
		props: {
			defaultItem:{
				type: Object,
				required: false,
				default:() => ({}),
			},
			vars:{
				type:Object,
				required:true
			},
			isCollection:{
				type:Boolean,
				required:false,
				default:null
			}
		},
		data() {
			return {
				nods: [],
				// skipQuery: true,// prevents a query when settiing filterInput to default
				filterInput: '',    // contains all characters the user has entered
				debouncedFilterString: null,
				filterString: null,
				showMatches: false,  // hide/show the search results
				listPointer: -1,   // determine which result is selected
				offset: 0, // the first result to return (use other than 0 for pagination, not req here)
				first: 10,   // number of search results to return
			}
		},
		apollo: {
			nods () {
				return {
					query: getNod,
					fetchPolicy: 'network-only',
					variables(){
						// Start with base where conditions
						const whereConditions = {
							name_CONTAINS: this.filterString,
						}
						// Only add isCollection condition if it's true
						if (this.vars.isCollection) {
							whereConditions.isCollection = true
						}	
						return{
							options: {
								sort:{
									name: "ASC",
								}
							},
							where: whereConditions
						}
					},
				}
			}
		},
		methods: {
			skipQuery (){
				if(this.vars.editOnly){  // alway skip Query
					return true
				}else if(this.filterInput == ''){
					this.nods = []
					return true  // don't query as there is nothing typed
				}else{
					return false
				}
			},
			comboKeyDown () { // navigate through the list and combo box
				let key = event.keyCode
				let pointer = this.listPointer
				let length  = this.nods.length
				// let matchLength = this.filterMatches.length
				// this.skipQuery = true
				// if you are not navigating then set pointer to -1
				switch(key){
					case 9:{		// Tab
							event.preventDefault()
							if(length > 0 && pointer == -1){
								this.listPointer = 0
							}
							this.showMatches = false
							this.emitSelection(this.selection)
						}
					break
					case 40:{		// arrow down
							event.preventDefault()
							if (pointer >= -1 && pointer < length-1){
								this.listPointer++
							}else{
								this.listPointer = -1
							}
						}
					break
					case 38:{		// arrow up
							event.preventDefault()
							if (pointer >= 0 && pointer < length){
								this.listPointer--
							}else{
								this.listPointer = length-1
							}
						}
					break
					case 27:		// esc
						// if there is text then clear it
						if(this.filterInput == this.defaultItem.name || this.filterInput ==''){
							// this.emitSelection(this.defaultItem)
							this.emitSelection(null)
						}else{
							this.filterInput = ''
						}
					break
					case !13:		// not enter
						this.listPointer = -1 // you are not navigating so it means you want to type
					break
				}
			},
			comboKeyEnter(){  // make selection by typing enter
				event.preventDefault()
				// console.log('enter')
				this.emitSelection(this.selection)
			},
			onListClick(item, index){ // make selection by click
				this.listPointer = index // causes computed this.selection to reflect selected item
				this.emitSelection(this.selection) // emit
			},
			emitSelection(selection,item){ // emit the selection
				// console.log('emitSelection -', selection, item)
				// sometimes there will not be a default so you need to create a blank one
				let defaultItem
				defaultItem = item ? item : {ID:'',name:'', created:null}
				const retVar = {item: selection}
				// console.log('emitSelection', retVar.item, selection)
				if(_.isEmpty(selection)){
					retVar.code = 0
					retVar.item = null
					// retVar.created = null
				}else{
					if(selection.name === ''){
							retVar.code = 0
							retVar.item = null
							// retVar.created = null
					}else if(selection.name.toLowerCase() == defaultItem.name.toLowerCase()){
						retVar.code = 0
						retVar.item = null
						// retVar.created = null
					}else{
						// if there is an ID then an existing Instance was selected
						if(selection.ID){
							// if selection and default ID are the same and editOnly is true
							if(
								selection.ID == this.defaultItem.ID){
								retVar.code = 1
							}else{
								retVar.code = 2
							}
						}else{
							retVar.code = 3
						}
					}
				}
				// console.log('emitSelection', retVar)
				this.$emit('selectedItem', retVar)
				// reset stuff
				this.listPointer = -1
				this.filterInput = ''
			}
		},  
		watch:{
			nods: function(){
				if (this.nods.length > 0){
					this.showMatches = true
				}else{
					this.showMatches = false
				}
			},
			filterInput: function(){
				let input = this.filterInput
				if (input == ''){
					this.filterString = null
				}else{
					this.filterString = this.filterInput
				}
			},
		},
		computed:{
			// set a minimum size for the box if no default item is provided
			textLen(){
				const txtLen = typeof this.defaultItem === "undefined"?0:_.isEmpty(this.defaultItem)?0:this.defaultItem.name.length
				return txtLen>0?txtLen:10
			},
			selection: function (){
				let pointer = this.listPointer
				if (pointer == -1){  // no list item is selected
					if(this.vars.editOnly){
						const newNod = {}
						newNod.ID = this.defaultItem.ID
						newNod.name = this.filterInput
						newNod.created = this.defaultItem.created
						newNod.__typename = this.defaultItem.__typename
						this.defaultItem.isCollection?newNod.isCollection=true:null
						return newNod
					}else{
						return {
							__typename:"Nod",
							created:null,
							name: this.filterInput
						}
					}
				}else{
					return this.nods[pointer]
				}
			}
		},
		mounted(){
			this.$refs.filterInput.focus()
			this.$nextTick(function () {
				if(!_.isEmpty(this.defaultItem)) {
					this.filterInput = this.defaultItem.name
				}
			})
		},
	}
</script>

<style scoped>

	.autocomplete{
		display: inline-flex;
	}

	.button{
		padding:0px 2px 0px 2px;
		border: 1px solid black;
		border-radius: 4px;
		display: inline-block;
		height: 24px;
		min-width: 17px;
	}

	.button-image{
		height: 15px;
		display:flex;
	}

	.button:hover{
		background-color: #a6f4e5;
	}

	.input{
		border: 1px solid black;
		border-collapse: collapse;
		height: 20px;
		margin-left: .5px;
		margin-right: .5px;
		padding-left: 5px;
		padding-right: 5px;
	}

	.dropdown{
		display: inline-block;
		min-width: 10px;
		overflow: visible;
		position: relative; /* anchor for absolutely positioned dropdown list */
	}

/*	position and z-index cause the list to appear on top of nearby elements and does not cause them to shift*/
	.dropdown--list {
		display:none;
		border: 1px solid black;
		background-color: #cff5a9;
		padding:5px;
		position: absolute;
		z-index: 10;
		margin: 0;
		left: 0;
		top: 100%; /* place list directly below input container */
		width: 100%; /* match width of input container */
	}

	.dropdown--list-show{
		display:block;
	}

	.dropdown--li {
		list-style-type: none;
		height: 16px;
		padding-left: 5px;
		padding-right: 5px;
	}

	.dropdown--li:hover {
		background-color: #a6f4e5;
		cursor: pointer;
	}

	.dropdown--li-active {
		background-color: #4AAE9B;
		color: white;
	}

</style>